'use client';
import {
    Budget,
    LanguageCode,
    MapBoxAddress,
    Principle,
    Software,
    StrapiDocument,
    TopicKnowledge,
    UploadedMedia,
    UploadType,
    User
} from '../../index';

export enum InstitutionType {
    Administration = 'administration',
    Association = 'association',
    Company = 'company'
}

export interface Institution extends StrapiDocument {
    type: InstitutionType;
    name: string;
    address: MapBoxAddress;
    website?: string;
    email?: string;
    phone?: string;
    slogan?: string;
    info?: { title?: string; text?: string };
    logo?: UploadedMedia<UploadType.Image>;
    media?: UploadedMedia<UploadType.Image>[];
    admins: User[];
    members: User[];
    isPublic?: boolean;
    used_software?: Software[];
    topicsKnowledge?: TopicKnowledge[];
    principles?: Principle[];
    budget?: Budget;
    languages: LanguageCode[];
}

export interface Administration extends Institution {
    type: InstitutionType.Administration;
}

export interface Association extends Institution {
    type: InstitutionType.Association;
}

export interface Company extends Institution {
    type: InstitutionType.Company;
    isPublic: boolean;
    used_software: Software[];
    topicsKnowledge: TopicKnowledge[];
    principles: Principle[];
}

export type FetchInstitutionInternalResponse = {
    institution: Institution | null;
    error?: Error;
};
export type FetchInstitutionsInternalResponse = {
    institutions: Institution[];
    error?: Error;
    totalNumberOfEntries?: number;
};
